<template>
    <div
        class="ds-text-icon"
        :class="{ 'ds-text-icon--icon-only': icon }"
        data-j-link-text>
        <!-- Icon only -->
        <DsIcon
            v-if="icon"
            :category="icon.category"
            :name="icon.name"
            data-j-link-icon-only />
        <!-- Text and optional icons -->
        <template v-else>
            <DsIcon
                v-if="iconLeft"
                class="ds-text-icon__icon ds-text-icon__icon--left"
                :class="[withSpacing ? 'ds-margin-right-12' : 'ds-margin-right-6']"
                :category="iconLeft.category"
                :name="iconLeft.name"
                data-j-icon-left /><!-- no whitespace here
            --><span v-if="text" data-j-text>{{ text }}</span><!-- no whitespace here
            --><DsIcon
            v-if="iconRight"
            class="ds-text-icon__icon ds-text-icon__icon--right"
            :class="[withSpacing ? 'ds-margin-left-12' : 'ds-margin-left-6']"
            :category="iconRight.category"
            :name="iconRight.name"
            data-j-icon-right />
        </template>
    </div>
</template>

<script>
import DsIcon from '../icon/icon';

export default {
    name: 'DsTextIconElement',
    components: { DsIcon },
    props: {
        /**
         * left icon (optional)
         */
        iconLeft: {
            type: [Object, null],
            default: null,
            validator: obj => ['name', 'category'].every(key => key in obj)
        },
        /**
         * right icon (optional)
         */
        iconRight: {
            type: [Object, null],
            default: null,
            validator: obj => ['name', 'category'].every(key => key in obj)
        },
        /**
         * icon (optional)
         */
        icon: {
            type: [Object, null],
            default: null,
            validator: obj => ['name', 'category'].every(key => key in obj)
        },
        /**
         * text (optional)
         */
        text: {
            type: String,
            default: ''
        },
        /**
         * Adds 12px icon spacing (optional)
         */
        withSpacing: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style lang="scss" scoped>
@import '../../foundation/tokens/variables';

.ds-text-icon {
    span,
    &__icon {
        vertical-align: middle;
    }

    &--icon-only {
        align-items: center;
        display: flex;
    }
}
</style>
